import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const CrearPlan = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/CrearPlan",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { CrearPlan };
